// 30.09.2026: атрибуція «звідки додали» до ЗАМОВЛЕННЯ. GA4 не зшиває наші списки з
// покупками (канал Shopify шле item_id shopify_ZZ_<product>_<variant>), тому пишемо
// last-touch джерело кожного варіанта в атрибут кошика _ps_src ("variantId=source;...").
// Атрибут їде в note_attributes замовлення; звіт: scripts/demand/add-source-report.mjs.
// Джерела: pdp | card-<surface> | rec-<block> | bump | cart-rec | cart-pack.
window.psAddSource = window.psAddSource || (function () {
  let chain = Promise.resolve()
  return function (variantId, source) {
    if (!variantId || !source) return chain
    chain = chain.then(async () => {
      const root = window.Shopify?.routes?.root || '/'
      const cart = await (await fetch(`${root}cart.js`, { credentials: 'same-origin' })).json()
      const map = new Map()
      String(cart.attributes?._ps_src || '').split(';').forEach((pair) => {
        const [id, src] = pair.split('=')
        if (id && src) map.set(id, src)
      })
      map.delete(String(variantId))
      map.set(String(variantId), String(source).replace(/[;=]/g, '-').slice(0, 40))
      const live = new Set((cart.items || []).map((item) => String(item.variant_id)))
      const value = [...map].filter(([id]) => live.has(id)).slice(-40).map(([id, src]) => `${id}=${src}`).join(';')
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _ps_src: value } })
      })
    }).catch(() => {})
    return chain
  }
})()

function psAddSourceOf(button) {
  if (!button || !button.closest) return 'other'
  if (button.closest('.ppc__buy, .ppc__mobile-dock-buy, .main-product__add-to-cart')) return 'pdp'
  const block = button.closest('[data-recommendation-block]')
  if (block) return `rec-${block.dataset.recommendationBlock}`
  const surface = typeof window.psCardSurface === 'function' ? window.psCardSurface(button) : 'other'
  return `card-${surface}`
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (event.target.closest(".search-trigger")) {
      event.preventDefault();
      document.getElementById("search-modal").classList.add("active");
      document.getElementById('Search').focus();
    }
  });

  document.getElementById("close-modal").addEventListener("click", function () {
    document.getElementById("search-modal").classList.remove("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  let activeFly = null
  const routesRoot = window.Shopify?.routes?.root || '/'

  const widget = document.getElementById('cart-widget')

  document.querySelector('.cart-widget__close')?.addEventListener('click', () => {
    clearTimeout(widget.hideTimeout)
    widget.classList.add('hidden')
  })

  function flyProductBox(button, event) {
    if (activeFly) {
      activeFly.remove()
      activeFly = null
    }

    const form = button.closest("form")

    const variantTitle = form?.querySelector('[name="variant_title"]')?.value
    const productTitle = form?.querySelector('[name="product_title"]')?.value

    const title =
      variantTitle && variantTitle.toLowerCase() !== "default title"
        ? variantTitle
        : productTitle || "Product"

    const widget = document.getElementById("cart-widget")
    if (!widget) return

    const rect = widget.getBoundingClientRect()

    const startX = event.clientX
    const startY = event.clientY

    const targetX = rect.left + rect.width / 2
    const targetY = rect.top + rect.height / 2

    const box = document.createElement("div")
    box.className = "fly-product-box"
    box.textContent = title

    box.style.left = `${startX}px`
    box.style.top = `${startY}px`

    document.body.appendChild(box)
    activeFly = box

    box.getBoundingClientRect()

    box.classList.add("animate", "jump")

    setTimeout(() => {
      const dx = targetX - startX
      const dy = targetY - startY

      box.classList.remove("jump")
      box.classList.add("fly")

      box.style.transform = `translate(${dx}px, ${dy}px) scale(.45)`
    }, 200)

    setTimeout(() => {
      box.classList.add("fade-out")
    }, 900)

    setTimeout(() => {
      box.remove()
      activeFly = null
    }, 1200)
  }

  const cart = {
    elements: {
      cartCount: document.querySelector(".cart-count"),
      cartLink: document.getElementById("show-cart"),
      cartDrawer: document.querySelector(".mini-cart"),
      overlay: document.querySelector(".cart-overlay"),
      closeButton: document.querySelector(".close-cart"),
      addToCartButtons: document.querySelectorAll(".add_to_cart_button, .main-product__add-to-cart")
    },
    timeout: null,


    init() {
      this.bindEvents();
    },

    bindEvents() {
      document.addEventListener("click", (e) => {
        const button = e.target.closest(".add_to_cart_button, .main-product__add-to-cart");

        if (button) {

          e.preventDefault();

          const clickedButton = e.target.closest("button") || button;

          flyProductBox(clickedButton, e);

          this.handleAddToCart(e, button);
        }
      });

      this.elements.closeButton?.addEventListener("click", () => this.closeCart());

      document.addEventListener("click", (e) => this.handleGlobalClick(e));

      document.addEventListener("click", (e) => this.handleCartActions(e));
    },

    async updateCart() {
      const wrapper = this.elements.cartDrawer.querySelector(".mini-cart__content-wrapper");
      wrapper.classList.add("is-loading");

      try {
        const res = await fetch(`${routesRoot}cart.js`);
        const cartData = await res.json();

        this.syncCodeDiscountFlag(cartData);
        this.updateCartCount(cartData.item_count);
        this.renderCart(cartData);
        this.updateCartSummary(cartData);
      } catch (error) {
        console.error("Ошибка при обновлении корзины", error);
      } finally {
        wrapper.classList.remove("is-loading");
      }
    },

    updateCartSummary(cartData) {
      const countDisplay = document.querySelector(".cart-count-display");
      if (countDisplay) {
        const count = cartData.item_count;
        countDisplay.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
      }

      const checkoutBtn = document.querySelector(".mini-cart__checkout-button");
      if (checkoutBtn) {
        const formattedPrice = (cartData.total_price / 100).toFixed(2);
        checkoutBtn.textContent = `Review Order • $${formattedPrice}`;
      }
    },

    updateCartCount(count) {
      if (this.elements.cartCount) {
        this.elements.cartCount.textContent = count;
        this.elements.cartCount.setAttribute("data-count", count);
      }
    },

    // Промокод не сумується з бандлом −10%: поки код у кошику, промо-рядок тоста ховаємо
    hasCodeDiscount: typeof window.psCartHasCode === 'boolean' ? window.psCartHasCode : false,

    syncCodeDiscountFlag(cartData) {
      const cartLevel = (cartData.cart_level_discount_applications || [])
        .some(d => d.type === 'discount_code')
      const lineLevel = (cartData.items || []).some(i =>
        (i.line_level_discount_allocations || []).some(a => a.discount_application?.type === 'discount_code'))
      this.hasCodeDiscount = cartLevel || lineLevel
      window.psCartHasCode = this.hasCodeDiscount
    },

    show(totalItems) {
      const widget = document.getElementById("cart-widget")
      if (!widget) return

      const promoBlock = widget.querySelector(".cart-widget__promo")
      const promoText = widget.querySelector(".promo-text")

      if (promoText) {
        if (this.hasCodeDiscount) {
          promoText.innerHTML = ""
          promoText.style.display = "none"
          promoText.classList.remove("is-success")
        } else if (totalItems > 1) {
          promoText.style.display = ""
          promoText.innerHTML = window.translations.cart.widget.promo_success
          promoText.classList.add("is-success")
        } else {
          promoText.style.display = ""
          promoText.innerHTML = window.translations.cart.widget.promo_add_more.replace(/10\s?%[^\s,.!]*/, '<span class="highlight">$&</span>')
          promoText.classList.remove("is-success")
        }
      }

      if (promoBlock) {
        promoBlock.style.display = this.hasCodeDiscount ? "none" : ""
        promoBlock.classList.toggle("active", !this.hasCodeDiscount && totalItems > 1)
      }

      widget.classList.remove("hidden")

      clearTimeout(widget.hideTimeout)
      widget.hideTimeout = setTimeout(() => {
        widget.classList.add("hidden")
      }, 4000)
    },

    async handleAddToCart(event, button) {
      event.preventDefault()

      if (button.dataset.cartBusy === "true") return

      const form = button.closest("form")
      if (!form) return

      const productId = form.querySelector('input[name="id"]')?.value
      if (!productId) return

      const quantityInput =
        form.querySelector(".main-product__quantity-input") ||
        form.querySelector('input[name="quantity"]')

      const quantity = Math.max(parseInt(quantityInput?.value || "1", 10), 1)

      const currentCount = parseInt(this.elements.cartCount?.getAttribute("data-count") || "0", 10)
      const predictedTotalItems = currentCount + quantity

      this.updateCartCount(predictedTotalItems)
      this.show(predictedTotalItems)
      button.dataset.cartBusy = "true"
      button.setAttribute("aria-busy", "true")

      try {
        const mainCartRoot = document.querySelector('[data-main-cart-section]')
        const mainCartSectionId = mainCartRoot?.dataset.sectionId
        const addPayload = {
          id: productId,
          quantity: quantity
        }

        if (mainCartSectionId) {
          addPayload.sections = [mainCartSectionId]
          addPayload.sections_url = `${routesRoot}cart`
        }

        const addResponse = await fetch(`${routesRoot}cart/add.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(addPayload)
        })

        const addData = await addResponse.json()
        if (!addResponse.ok) {
          throw new Error(addData.description || addData.message || `Cart add failed with ${addResponse.status}`)
        }

        window.psAddSource(productId, psAddSourceOf(button))

        const renderedMainCart = mainCartSectionId ? addData.sections?.[mainCartSectionId] : null
        if (mainCartSectionId) {
          document.dispatchEvent(new CustomEvent('promosound:cart-section-rendered', {
            detail: {
              sectionId: mainCartSectionId,
              html: renderedMainCart || null
            }
          }))
        }

        try {
          const res = await fetch(`${routesRoot}cart.js`)
          if (!res.ok) throw new Error(`Cart fetch failed with ${res.status}`)
          const cartData = await res.json()

          this.syncCodeDiscountFlag(cartData)
          this.updateCartCount(cartData.item_count)
          this.updateCartSummary(cartData)
          this.renderCart(cartData)
          this.show(cartData.item_count)
        } catch (refreshError) {
          // The add mutation already succeeded. Keep the truthful predicted count;
          // the rendered main-cart section remains the authoritative cart UI.
          console.warn("Cart added, but secondary cart refresh failed:", refreshError)
          this.updateCartCount(predictedTotalItems)
          this.show(predictedTotalItems)
        }
      } catch (error) {
        console.error("Error adding to cart:", error)
        this.updateCartCount(currentCount)
        this.show(currentCount)
      } finally {
        delete button.dataset.cartBusy
        button.removeAttribute("aria-busy")
      }
    },

    async handleCartActions(event) {
      const btn = event.target;
      const itemEl = btn.closest(".mini-cart__item");
      if (!itemEl) return;

      const variantId = btn.dataset.id;
      const quantityEl = itemEl.querySelector(".mini-cart__quantity-controls span");
      let quantity = parseInt(quantityEl.textContent);

      if (btn.classList.contains("quantity-increase")) {
        quantity++;
        quantityEl.textContent = quantity;
      } else if (btn.classList.contains("quantity-decrease") && quantity > 1) {
        quantity--;
        quantityEl.textContent = quantity;
      } else if (btn.classList.contains("remove-item")) {
        await this.removeItem(variantId);
        return this.updateCart();
      }

      if (btn.classList.contains("quantity-increase") || btn.classList.contains("quantity-decrease")) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await fetch(`${routesRoot}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity })
          });
          await this.updateCart();
        }, 300);
      }
    },

    async removeItem(id) {
      await fetch(`${routesRoot}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity: 0 })
      });
    },

    addItemToMiniCart(data) {
      const cartCountEl = this.elements.cartCount;
      const cartDrawerContent = this.elements.cartDrawer.querySelector(".mini-cart__content");
      const existingItem = cartDrawerContent.querySelector(`[data-id="${data.key}"]`);

      const current = parseInt(cartCountEl?.getAttribute("data-count") || "0", 10);

      const emptyMsg = this.elements.cartDrawer.querySelector(".empty__cart");
      if (emptyMsg) emptyMsg.remove();

      if (existingItem) {
        const qtyEl = existingItem.querySelector(".mini-cart__quantity-controls span");
        const priceEl = existingItem.querySelector(".mini-cart__price");
        const newQty = parseInt(qtyEl.textContent, 10) + data.quantity;
        qtyEl.textContent = newQty;
        priceEl.textContent = `${newQty} x $${(data.final_line_price / 100).toFixed(2)}`;
      } else {
        cartDrawerContent.insertAdjacentHTML("afterbegin", this.getCartItemHTML(data));
      }
    },


    async renderCart(cart) {
      const cartDrawerContent = this.elements.cartDrawer.querySelector(".mini-cart__content");
      // arrow-обгортка зберігає this=cart: bare this.getCartItemHTML у .map губив прив'язку
      // → всередині this undefined → "this.getCartIconClass is not a function".
      cartDrawerContent.innerHTML = cart.items.map(item => this.getCartItemHTML(item)).join("");

      const cartDrawerWrapper = this.elements.cartDrawer.querySelector(".mini-cart__content-wrapper");
      const recommendationsContainer = document.getElementById('cart-recommendation');
      recommendationsContainer.innerHTML = '';

      const seenProductIds = new Set();

      if (cart.items.length > 0) {
        for (const item of cart.items) {
          try {
            const recs = await this.fetchRecommendations(item.product_id);
            const uniqueRecs = recs.filter(p => !seenProductIds.has(p.id));

            if (uniqueRecs.length > 0) {
              uniqueRecs.forEach(p => seenProductIds.add(p.id));
              const recsHTML = uniqueRecs.map(product => this.getRecommendationHTML(product)).join('');
              recommendationsContainer.insertAdjacentHTML('beforeend', recsHTML);
            }
          } catch (error) {
            console.error('Ошибка загрузки рекомендаций для продукта', item.product_id, error);
          }
        }
      } else {
        try {
          const recs = await this.fetchRecommendations(8541115613362);
          if (recs.length > 0) {
            const uniqueRecs = recs.filter(p => !seenProductIds.has(p.id));
            uniqueRecs.forEach(p => seenProductIds.add(p.id));
            const recsHTML = uniqueRecs.map(product => this.getRecommendationHTML(product)).join('');
            recommendationsContainer.insertAdjacentHTML('beforeend', recsHTML);
          }
        } catch (error) {
          console.error('Ошибка загрузки рекомендаций для продукта 8541115613362', error);
        }
      }

      const instance = SimpleBar.instances.get(cartDrawerWrapper);
      if (instance) {
        instance.recalculate();
      } else {
        new SimpleBar(cartDrawerWrapper);
      }

    },

    // 20.10.2026: замість рідного products.json - секція product-complementary-json (snippets/product-card-json).
    // У products.json нема метаполів, тому прихований варіант (custom.hidden) ішов би в «Add» як variants[0],
    // а ціна - з усіх варіантів. product-card-json віддає лише видимі варіанти і price = мінімум видимих.
    // Без Accept: application/json - інакше Shopify замість секції віддає products.json (BUNDLES-FLOW §11.8).
    async fetchRecommendations(productId, limit = 4) {
      const url = `${routesRoot}recommendations/products?section_id=product-complementary-json&product_id=${productId}&limit=${limit}&intent=related`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch recommendations');
      const text = await response.text();
      const holder = document.createElement('div');
      holder.innerHTML = text;
      const sectionEl = holder.querySelector('.shopify-section') || holder;
      const products = JSON.parse((sectionEl.textContent || '').trim() || '[]');
      return Array.isArray(products) ? products : [];
    },

    getRecommendationHTML(product) {
      const price = (product.price / 100).toFixed(2);
      const compareAtPrice = product.compare_at_price > product.price
        ? (product.compare_at_price / 100).toFixed(2)
        : null;

      const variantId = product.variants?.[0]?.id || product.id;

      return `
    <div class="recommendation-item" data-id="${product.id}">
      <div class="recommendation-item__image">
      </div>
      <div class="recommendation-item__content">
        <div class="recommendation-item__header">
          <a href="${String(product.url).split("?")[0]}" class="recommendation-item__title">${product.title}</a>
        </div>
        <div class="recommendation-item__footer">
          <div class="recommendation-item__price">
            <span class="price-current">$${price}</span>
            ${compareAtPrice ? `<del class="price-compare">$${compareAtPrice}</del>` : ''}
          </div>
          <form class="ajax-add-to-cart-form">
            <input type="hidden" name="id" value="${variantId}">
            <input type="hidden" name="product_title" value="${product.title}">
            <input type="hidden" name="price" value="${product.price}">
            <input type="hidden" name="compare_at_price" value="${product.compare_at_price || ''}">
            <input type="hidden" name="quantity" value="1">
            <button
              type="button"
              class="add_to_cart_button recommendation-btn btn btn-primary add-to-cart"
              data-product-id="${variantId}"
            >
              Add
            </button>
          </form>
        </div>
      </div>
    </div>
  `;
    },


    getCartIconClass(item) {
      const source = [
        item.product_type,
        item.handle,
        String(item.url).split("?")[0],
        item.title,
        item.product_title
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      const productType = (item.product_type || "").toLowerCase();

      const handleize = (value) => value
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      if (source.includes("soundcloud") || source.includes("s-cloud")) return "";
      if (productType.includes("promotion sub")) {
        return handleize(productType.replace("promotion sub", "promotion"));
      }
      if (source.includes("spotify")) return "spotify-promotion";
      if (source.includes("youtube")) return "youtube-promotion";
      if (source.includes("instagram")) return "instagram-promotion";
      if (source.includes("tiktok")) return "tiktok-promotion";
      if (source.includes("facebook")) return "facebook-promotion";
      if (source.includes("twitch")) return "twitch-promotion";
      if (source.includes("beatport")) return "beatport-promotion";
      if (source.includes("resident advisor")) return "resident-advisor-promotion";
      if (source.includes("traxsource")) return "traxsource-top-100-promotion";
      if (source.includes("deezer")) return "deezer-promotion";
      if (source.includes("tidal")) return "tidal-promotion";
      if (source.includes("audiomack") || source.includes("audiomac")) return "buy-audiomack-plays";
      if (source.includes("bandcamp")) return "bandcamp-promotion";
      if (source.includes("pandora")) return "buy-pandora-music-plays";
      if (source.includes("napster")) return "buy-napster-plays";
      if (source.includes("mixcloud")) return "mixcloud-promotion";
      if (source.includes("threads")) return "threads-promotion";
      if (source.includes("apple music")) return "buy-apple-music-streams";
      if (source.includes("itunes") || source.includes("itune")) return "itunes-top-100-promotion-usa";
      if (source.includes("radio airplay")) return "radio-airplay";
      if (source.includes("music blogs") || source.includes("blog placement")) return "music-blogs-placement";
      if (source.includes("hip-hop") || source.includes("hip hop")) return "hip-hop-promotion";
      if (source.includes("artist")) return "artist-promotion";
      if (source.includes("music guides")) return "music-guides";

      return item.product_type
        ? handleize(item.product_type.toLowerCase())
        : "";
    },


    getCartItemHTML(item) {
      // Вигода видима і в дроуері (W1, 28.08). ВАЖЛИВО: у /cart.js алокація
      // cart-level промокода сидить у line_price/discounted_price, а
      // final_line_price її НЕ включає — тому порівнюємо original vs line_price.
      const finalCents = item.line_price != null ? item.line_price : item.final_line_price;
      const price = (finalCents / 100).toFixed(2);
      const isDiscounted = item.original_line_price > finalCents;
      const comparePrice = isDiscounted ? (item.original_line_price / 100).toFixed(2) : null;

      const validDiscount = item.discounts?.find(d => d.amount > 0);
      const discountTitle = validDiscount ? validDiscount.title : null;

      const productTypeClass = this.getCartIconClass(item);

      return `
    <div class="mini-cart__item" data-id="${item.key || item.variant_id}">
      <div class="mini-cart__details">
        <span>${item.title ? `${item.title}` : `${item.product_title}`}</span>
        <div class="mini-cart__bottom-row">
          <div class="mini-cart__item-image ${productTypeClass}"></div>
          <div class="mini-cart__quantity-controls">
            <button class="quantity-decrease" data-id="${item.key || item.variant_id}"></button>
            <span>${item.quantity}</span>
            <button class="quantity-increase" data-id="${item.key || item.variant_id}"></button>
          </div>
          <button class="remove-item" data-id="${item.key || item.variant_id}"></button>
          <span class="mini-cart__price">
            ${discountTitle ? `<div class="discount-title">${discountTitle}</div>` : ""}
            ${isDiscounted ? `<del>$${comparePrice}</del>` : ""}
            $${price}
          </span>
        </div>
      </div>
    </div>
  `;
    },

    openCart() {
      this.elements.cartDrawer?.classList.add("visible");
      this.elements.overlay?.classList.add("active");
      document.body.classList.add("cart-open");
    },

    closeCart() {
      this.elements.cartDrawer?.classList.remove("visible");
      this.elements.overlay?.classList.remove("active");
      document.body.classList.remove("cart-open");
    },

    handleGlobalClick(event) {
      const { target } = event;
      if (
        !this.elements.cartDrawer.contains(target) &&
        !target.closest(".cart__link") &&
        !target.closest(".add-to-cart") &&
        !target.closest(".main-product__add-to-cart") &&
        !target.closest(".variant-select__option")
      ) {
        this.closeCart();
      }
    }
  };

  cart.init();

  window.cart = cart;
});
